import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.dispatchEvent(new CustomEvent("dropdown:close-all"))
    document.body.classList.add("overflow-hidden")
    this.previouslyFocusedElement = document.activeElement
    requestAnimationFrame(() => {
      this.backdrop?.classList.remove("opacity-0")
      this.backdrop?.classList.add("opacity-100")
      this.dialog?.classList.remove("opacity-0", "translate-y-2", "scale-95")
      this.dialog?.classList.add("opacity-100", "translate-y-0", "scale-100")
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.focusInitialElement(), 200)
    })
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    if (!this.element.isConnected) this.previouslyFocusedElement?.focus()
  }

  close() {
    this.backdrop?.classList.remove("opacity-100")
    this.backdrop?.classList.add("opacity-0")
    this.dialog?.classList.remove("opacity-100", "translate-y-0", "scale-100")
    this.dialog?.classList.add("opacity-0", "translate-y-2", "scale-95")

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.remove(), 200)
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape") this.close()
  }

  get dialog() {
    return this.element.querySelector("[role='dialog']")
  }

  get backdrop() {
    return this.element
  }

  focusInitialElement() {
    const autofocusElement = this.element.querySelector("[autofocus]")

    if (autofocusElement) {
      autofocusElement.focus()
      return
    }

    this.dialog?.focus()
  }
}
